import { Component, OnInit } from '@angular/core';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { FieldCustomizationService } from '../services/field-customization/field-customization.service';

@Component({
  selector: 'app-visit-config',
  templateUrl: './visit-config.component.html',
  styleUrls: ['./visit-config.component.css']
})
export class VisitConfigComponent implements OnInit {

  accounts: any = [];
  accountId: number = null;
  addNewConfig: boolean = false;
  showData: boolean = false;
  disableButtonFlag: boolean = false;
  fields: any = [{ "id": "SUBJECTIVE", "label": "Subjective" }, { "id": "OBJECTIVE", "label": "Objective" }];
  customFieldsCopy: any = [
    { "id": null, "refractionType": "OBJECTIVE", "fieldName": "Sphere", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "OBJECTIVE", "fieldName": "Cylinder", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "OBJECTIVE", "fieldName": "Axis", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "SUBJECTIVE", "fieldName": "Sphere", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "SUBJECTIVE", "fieldName": "Cylinder", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "SUBJECTIVE", "fieldName": "Axis", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    // { "id":null,"refractionType": "VISUAL_ACUITY","fieldName":"Visual_Acuity","fieldMinValue":"","fieldMaxValue":"","fieldStepValue":"","isMandatory":false,"fieldAdditionalnfo":"","accountId":this.accountId },
    // { "id":null,"refractionType": "VISUAL_ACUITY","fieldName":"Visual_Acuity_Left","fieldMinValue":"","fieldMaxValue":"","fieldStepValue":"","isMandatory":false,"fieldAdditionalnfo":"","accountId":this.accountId },
  ];
  customFields: any = [
    { "id": null, "refractionType": "OBJECTIVE", "fieldName": "Sphere", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "OBJECTIVE", "fieldName": "Cylinder", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "OBJECTIVE", "fieldName": "Axis", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "SUBJECTIVE", "fieldName": "Sphere", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "SUBJECTIVE", "fieldName": "Cylinder", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    { "id": null, "refractionType": "SUBJECTIVE", "fieldName": "Axis", "fieldMinValue": "", "fieldMaxValue": "", "fieldStepValue": "", "isMandatory": false, "fieldAdditionalnfo": "", "accountId": this.accountId },
    // { "id":null,"refractionType": "VISUAL_ACUITY","fieldName":"Visual_Acuity","fieldMinValue":"","fieldMaxValue":"","fieldStepValue":"","isMandatory":false,"fieldAdditionalnfo":"","accountId":this.accountId },
    // { "id":null,"refractionType": "VISUAL_ACUITY","fieldName":"Visual_Acuity_Left","fieldMinValue":"","fieldMaxValue":"","fieldStepValue":"","isMandatory":false,"fieldAdditionalnfo":"","accountId":this.accountId },
  ];
  masterDataConfigurationList: any = []

  constructor(public accountService: AccountService, public foruscareService: ForuscareService, public fieldCustomizationService: FieldCustomizationService) { }

  ngOnInit() {
    this.getAvailableAccounts();
    // this.customFieldConfig.customFields = [];
  }

  fetchWorkflowDetailsForAccount() {
    this.showData = false;
    this.accountService.getAccountWorkflowByAccountId(this.accountId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.length > 0) {
            response.data.forEach(data => {
              if (data.serviceName == "REFRACTION") {
                this.showData = true;
                this.getRefractionConfig(this.accountId);
                return;
              }
            });
            this.foruscareService.showNotification("Refraction workflow is not configured for this account", "danger");
          }
          else {
            this.foruscareService.showNotification("Refraction workflow is not configured for this account", "danger");
          }
        } else {
          this.foruscareService.showNotification("Refraction workflow is not configured for this account", "danger")
        }
      });
  }

  getRefractionConfig(accountId) {
    // this.accountId = accountId;

    this.accountService.getRefractionConfigByAccount(this.accountId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              this.foruscareService.showNotification(response.data.length + " configs found", "success");
              this.masterDataConfigurationList = response.data;
              this.filterData();
            } else {
              this.foruscareService.showNotification("No configs found", "danger");
              this.customFields = this.customFieldsCopy.map(x => Object.assign({}, x));
            }
          }
        }
        else {
          this.foruscareService.showNotification("No configs found", "danger");
          this.customFields = this.customFieldsCopy.map(x => Object.assign({}, x));
        }
      });
  }

  filterData() {
    this.customFields.forEach((item, index) => {
      let matchFound = false;
      this.masterDataConfigurationList.forEach((masterDataItem, index) => {
        if (item.fieldName == masterDataItem.fieldName && item.refractionType == masterDataItem.refractionType) {
          item = Object.assign(item, masterDataItem);
          matchFound = true;
        }
      });
      // if( !matchFound ) {
      //   if( index < 6 )
      //     item = Object.assign(item, { "id":null,"refractionType": index < 3 ? "SUBJECTIVE" : "OBJECTIVE","fieldName":item.fieldName,"fieldMinValue":"","fieldMaxValue":"","fieldStepValue":"","isMandatory":false,"fieldAdditionalnfo":"","accountId":this.accountId });
      //   } else {
      //     item = Object.assign(item, { "id":null,"refractionType": index < 3 ? "SUBJECTIVE" : "OBJECTIVE","fieldName":item.fieldName,"fieldMinValue":"","fieldMaxValue":"","fieldStepValue":"","isMandatory":false,"fieldAdditionalnfo":"","accountId":this.accountId });
      //   } 
    });
  }

  validateLength(minCount, maxCount, stepValue, fieldName) {
    this.disableButtonFlag = false;
    // if(minCount!=null && maxCount!=null && minCount>=maxCount ){
    //   this.foruscareService.showNotification("Min length cannot be greater than OR equal to Max length", "warning");
    //   this.disableButtonFlag=true;
    // }
    // if( stepValue!=null && stepValue < minCount && stepValue > maxCount) {
    //   this.foruscareService.showNotification("Step value cannot be greater Max length or less than min length", "warning");
    //   this.disableButtonFlag=true;
    // }
    // if( stepValue!=null && stepValue === 0) {
    //   this.foruscareService.showNotification("Step value cannot be zero", "warning");
    //   this.disableButtonFlag=true;
    // }

    if (fieldName == 'Axis') {
      if (!Number.isInteger(minCount) || minCount > maxCount) {
        this.foruscareService.showNotification("Minimum value cannot be less than zero or greater than max length and cannot be a deicmal value", "warning");
        this.disableButtonFlag = true;
      }
      if (maxCount <= minCount || maxCount > 180 || !Number.isInteger(maxCount)) {
        this.foruscareService.showNotification("Maximum value cannot be less than minimum or greater than 180 and cannot be a decimal value", "warning");
        this.disableButtonFlag = true;
      }

      if (stepValue <= 0 || stepValue > maxCount || ((typeof stepValue == 'string') && stepValue.indexOf(".") !== -1)) {
        this.foruscareService.showNotification("Step value should be between minimum and maximum value and cannot be a deicmal value", "warning");
        this.disableButtonFlag = true;
      }
    }

    //this.disableButton();
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getPayloadData(): any {
    let requestArr = [];
    let isOneFilled = false;
    this.customFields.forEach((item) => {
      let areMandatoryFieldsFilled = true;
      if (item.id == null && (item.fieldMinValue != 0 && item.fieldMinValue == "" || (item.fieldMaxValue == "") || item.fieldStepValue == "") && !item.fieldName.includes('Visual')) {
        console.log('true');
        areMandatoryFieldsFilled = false;
        return requestArr;
      }

      if (areMandatoryFieldsFilled || item.id != null || (item.fieldName.includes('Visual') && item.fieldAdditionalnfo != "")) {
        item.accountId = this.accountId;
        requestArr.push(item);
        isOneFilled = true;
      }
    });
    return requestArr;
  }

  saveRefractionConfig() {
    let payloadArray = [];
    payloadArray = this.getPayloadData();
    if (payloadArray.length == 0) {
      this.foruscareService.showNotification("Please fill in all mandatory fields", "danger");
    } else {
      this.fieldCustomizationService.saveRefractionConfig(payloadArray)
        .subscribe(response => {
          if (response.errorCode == 200) {
            this.foruscareService.showNotification(response.message, "success");
            this.getRefractionConfig(this.accountId);
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }

  }
}
